export default __webpack_public_path__ + "static/raimond2-d346a626508055d6995a637d20bc7d4e.jpg";